import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Table, TableBody, TableHeader, TableHeaderCell, TableRow, TableRowCell } from 'components/Table';
import { Spinner } from 'components';
import TextField from 'material-ui/TextField';
import * as styles from './DataTable.scss';
import { get as getField } from 'lodash';
var DataTable = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(DataTable, _Component);

  var _super = _createSuper(DataTable);

  function DataTable(props) {
    var _this;

    _classCallCheck(this, DataTable);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "renderTableBody", function () {
      var items = _this.props.data;
      return items.map(function (obj, index) {
        return /*#__PURE__*/React.createElement(TableRow, {
          key: index,
          onClick: _this.handleRowSelection.bind(_assertThisInitialized(_this), obj)
        }, _this.props.headerFields.map(function (header, idx) {
          return /*#__PURE__*/React.createElement(TableRowCell, {
            key: idx,
            style: _this.props.firstColColored && idx === 0 ? {
              color: _this.props.theme.colors.secondaryColor,
              fontWeight: '400',
              whiteSpace: 'normal'
            } : {
              whiteSpace: 'normal'
            }
          }, _this.handleFieldRender(obj, header));
        }));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFieldRender", function (obj, header) {
      var value = function () {
        if (header.renderAs) {
          return header.renderAs(obj);
        }

        if (typeof obj[header.key] === 'function') {
          return obj[header.key]();
        }

        if (header.key instanceof Array) {
          return _toConsumableArray(header.key).map(function (str) {
            return getField(obj, str);
          }).join(' ');
        }

        return getField(obj, header.key);
      }();

      return !value ? header.hasOwnProperty('defaultValue') ? header.defaultValue : 'Unknown' : header.hasOwnProperty('transform') && typeof header.transform === 'function' ? header.transform(value) : value;
    });

    _defineProperty(_assertThisInitialized(_this), "handleRowSelection", function (rowData) {
      if (!_this.props.isLoading) {
        _this.props.onRowSelection(rowData);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSearchValueChanged", function (event, value) {
      _this.props.searchValueChanged(value);
    });

    _defineProperty(_assertThisInitialized(_this), "renderSortIcon", function (f) {
      if (_this.props.hideSort) {
        return '';
      }

      return _this.props.columnSort && _this.props.columnSort.key === f.key ? /*#__PURE__*/React.createElement("i", {
        className: "fa fa-md fa-sort-".concat(_this.props.columnSort.order, " ").concat(styles.sortIcon, " ").concat(styles.sortIconActive)
      }) : /*#__PURE__*/React.createElement("i", {
        className: "fa fa-md fa-sort ".concat(styles.sortIcon)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderTable", function () {
      return /*#__PURE__*/React.createElement(Table, {
        firstColColored: true
      }, _this.props.headerFields && _this.props.headerFields.length ? /*#__PURE__*/React.createElement(TableHeader, {
        style: _this.props.stickyHeader ? {
          position: 'sticky',
          top: 0,
          background: 'white'
        } : null
      }, _this.props.headerFields.map(function (f, idx) {
        return /*#__PURE__*/React.createElement(TableHeaderCell, {
          key: idx
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.tableHeader,
          onClick: function onClick() {
            return f.disableSort === true ? null : _this.props.onHeaderCellClick ? _this.props.onHeaderCellClick(f) : null;
          },
          style: _this.props.hideSort ? {
            cursor: 'default'
          } : {}
        }, f.name, " ", f.disableSort === true ? null : _this.renderSortIcon(f)));
      })) : null, /*#__PURE__*/React.createElement(TableBody, null, _this.renderTableBody()));
    });

    _this.state = {
      currentPage: 0
    };
    return _this;
  }

  _createClass(DataTable, [{
    key: "render",
    value: function render() {
      if (this.props.isLoading && this.props.displayLoading) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement(Spinner, {
          style: {
            marginLeft: 'auto',
            marginRight: 'auto'
          }
        }));
      }

      return /*#__PURE__*/React.createElement("div", {
        style: this.props.style
      }, /*#__PURE__*/React.createElement("div", {
        className: this.props.noRowClasses ? '' : 'row',
        style: {
          marginBottom: 12
        }
      }, this.props.showPaginationCount && /*#__PURE__*/React.createElement("div", {
        className: "col-xs-2 ".concat(styles.paginationCount)
      }), this.props.displaySearch && /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12 col-md-6 col-lg-3 ".concat(styles.searchWrap)
      }, /*#__PURE__*/React.createElement("div", {
        className: "",
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "".concat(styles.searchIcon, " icon ion-ios-search")
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          paddingRight: 12,
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(TextField, {
        style: {
          height: 38
        },
        underlineShow: false,
        hintStyle: {
          bottom: 7
        },
        inputStyle: {
          height: 38
        },
        fullWidth: true,
        hintText: this.props.searchInputPlaceholder,
        onChange: this.handleSearchValueChanged
      }))), this.props.extraSearchRowElement && /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12 col-md-offset-1 col-md-6 col-lg-3"
      }, this.props.extraSearchRowElement), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-3 ".concat(styles.userFilter)
      })), /*#__PURE__*/React.createElement("div", {
        className: this.props.noRowClasses ? '' : 'row'
      }, this.renderTable()));
    }
  }]);

  return DataTable;
}(Component), _defineProperty(_class2, "propTypes", {
  headerFields: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  searchIcon: PropTypes.string,
  searchInputPlaceholder: PropTypes.string,
  displayRowCheckbox: PropTypes.bool,
  multiSelectable: PropTypes.bool,
  selectable: PropTypes.bool,
  headerStyle: PropTypes.object,
  footerStyle: PropTypes.object,
  bodyStyle: PropTypes.object,
  displaySearch: PropTypes.bool,
  searchValueChanged: PropTypes.func,
  onRowSelection: PropTypes.func,
  onHeaderCellClick: PropTypes.func,
  showRowHover: PropTypes.bool,
  isLoading: PropTypes.bool,
  fixedHeader: PropTypes.bool,
  height: PropTypes.number,
  hideSort: PropTypes.bool
}), _defineProperty(_class2, "defaultProps", {
  searchIcon: 'fa fa-lg fa-search',
  searchInputPlaceholder: 'Search...',
  displayRowCheckbox: false,
  multiSelectable: false,
  selectable: true,
  headerStyle: {},
  footerStyle: {},
  bodyStyle: {},
  displaySearch: true,
  searchValueChanged: function searchValueChanged() {},
  onRowSelection: function onRowSelection() {},
  headerFields: [],
  data: [],
  onHeaderCellClick: function onHeaderCellClick() {},
  showRowHover: true,
  isLoading: false,
  fixedHeader: false,
  height: null,
  firstColColored: false,
  extraSearchRowElement: null,
  hideSort: false,
  noRowClasses: false
}), _defineProperty(_class2, "defaultProps", {
  style: {},
  onRowSelection: function onRowSelection() {
    return false;
  }
}), _temp)) || _class);
export default DataTable;